import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bess_admin_token") || localStorage.getItem("bess_reader_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith("/admin") && !path.endsWith("/admin/login")) {
        localStorage.removeItem("bess_admin_token");
        window.location.assign("/admin/login?expired=1");
      } else {
        // Reader session expired — clear it so the Read tab re-locks (handled in-page).
        localStorage.removeItem("bess_reader_token");
      }
    }
    return Promise.reject(err);
  }
);

export const COUNTRY_FLAGS = {
  BE: "🇧🇪", BG: "🇧🇬", EE: "🇪🇪", LV: "🇱🇻", LT: "🇱🇹", DK: "🇩🇰",
  DE: "🇩🇪", FR: "🇫🇷", IT: "🇮🇹", ES: "🇪🇸", PT: "🇵🇹", FI: "🇫🇮",
  SE: "🇸🇪", PL: "🇵🇱", GB: "🇬🇧", RO: "🇷🇴", NL: "🇳🇱",
};
